import { match } from 'ts-pattern';
import type { CMSBannerTheme } from '../schemas';

export const getBannerThemeStyles = (theme: CMSBannerTheme) => {
  return (
    match(theme)
      .with('dark', () => [
        // Default styles
        'bg-deep-teal-800',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-deep-teal-50",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-white",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:!text-spearmint-500",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-white",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-white",

        // Set text deep teal 100 to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-deep-teal-50",

        "[&_[data-component='CMSCTAButton']_a]:text-deep-teal-50",
      ])
      .with('light', () => [
        // Default styles
        'bg-lime-50 text-deep-teal-700',

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-deep-teal-700",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-deep-teal-700",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-deep-teal-700",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-deep-teal-700",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-deep-teal-700",

        // Add text color for CMSInlineTextImage, example: flags
        "[&_[data-component='CMSColumnsStandard']_[data-component='CMSTextAdvanced']_[data-component='CMSInlineTextImage']_.richText]:text-deep-teal-700",

        "[&_[data-component='CMSCTAButton']_a]:text-deep-teal-700",
      ])
      .with('grey', () => [
        'bg-grey-50',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-deep-teal-700",

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-deep-teal-700",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-deep-teal-700",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-deep-teal-700",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-deep-teal-700",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-deep-teal-700",

        "[&_[data-component='CMSCTAButton']_a]:text-deep-teal-700",
      ])

      // NEW BRAND UPDATES THEME
      .with('white', () => [
        'bg-white',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-black",

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-black",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-black",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-black",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-black",

        "[&_[data-component='CMSCTAButton']_a]:text-black",
      ])

      .with('black', () => [
        'bg-black',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-white",

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-white",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-white",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-white",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-white",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-white",
        // HR within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(hr)]:text-dark-grey-500",

        //CMSCard
        "[&_[data-component='CMSCard']_[data-component='CMSText']]:text-white",
        "[&_[data-component='CMSCard']_.heading]:text-white",
        "[&_[data-component='CMSCard']_.icon]:text-white",

        //CMSCarousel
        "[&_[data-component='CMSColumnsCarousel']_.CarouselIndicators_[data-active=true]]:text-white",
        "[&_[data-component='CMSColumnsCarousel']_.CarouselIndicators_[data-active=false]]:text-dark-grey-500",
        "[&_[data-component='CMSColumnsCarousel']_.CarouselArrows]:text-white",
      ])
      .with('light-grey-50', () => [
        'bg-light-grey-50',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-black",

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-black",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-black",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-black",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-black",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-black",

        "[&_[data-component='CMSCTAButton']_a]:text-black",
      ])
      .with('light-grey-100', () => [
        'bg-light-grey-100',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-black",

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-black",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-black",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-black",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-black",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-black",

        "[&_[data-component='CMSCTAButton']_a]:text-black",
      ])
      .with('light-grey-200', () => [
        'bg-light-grey-200',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-black",

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-black",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-black",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-black",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-black",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-black",

        "[&_[data-component='CMSCTAButton']_a]:text-black",
      ])
      .with('warp-green-50', () => [
        'bg-warp-green-50',
        // <p> and <small> tags within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(p,small)]:text-black",

        // Set text deep teal to rich text
        "[&_[data-component='CMSInlineTextImage']_.richText]:text-black",
        // H1 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h1)]:text-black",
        // H2 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h2)]:text-black",
        // H3 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h3)]:text-black",
        // H4 headings within CMSTextAdvanced component
        "[&_[data-component='CMSTextAdvanced']_:is(h4)]:text-black",

        "[&_[data-component='CMSCTAButton']_a]:text-black",
      ])

      // TODO: add default value
      .otherwise(() => '')
  );
};
